/* tslint:disable:max-classes-per-file */

import { ProgressScreeningRequestStatusRequestNoEnum } from "../enums";

/**
 * 選考概要情報
 */
export class JobScreeningInfo {
  /** ID */
  id?;

  /** 種別 */
  type: JobScreeningInfoType | "" = "";

  /** no */
  no?: ProgressScreeningRequestStatusRequestNoEnum;

  /** 会場名 */
  location? = '';

  /** 会場住所 */
  address? = '';

  /** 会場最寄駅 */
  nearestStation? = '';

  /** 所要時間 */
  duration? = '';

  /** 緊急連絡先 */
  emergencyContact? = '';

  /** 持参物 */
  preparation? = '';

  /** 対応事項1 */
  request1? = '';

  /** 対応事項2 */
  request2? = '';

  /** 対応事項3 */
  request3? = '';

  /** 対応期限1 */
  request1Deadline? = '';

  /** 対応期限2 */
  request2Deadline? = '';

  /** 対応期限3 */
  request3Deadline? = '';

  /** その他対応事項 */
  remarks? = '';
}

/**
 * 日程調整情報
 */
export class ScheduleInfo {
  /** 進捗ID */
  progressId = 0;

  /** 企業名 */
  enterpriseName = '';

  /** ポジション名 */
  position = '';

  /** N次選考 */
  n = 1;

  /** 担当者からの連絡事項 */
  contactFromAdvisor = '';

  /** 対応事項 */
  correspondence = '';

  /** セミナー日時 */
  seminarAt: Date | null = null;

  /** セミナー種別 */
  seminarType = 0;

  /** 選考概要有無 */
  isOverview = false;

  /** 選考概要 */
  screeningInfo = new JobScreeningInfo();
}

export const SCREENING_INFO_REQUEST_DEADLINE_OPTIONS = [
  { label: '-----', value: null },
  { label: '送信時指定', value: 999 },
  { label: '3営業日前', value: -3 },
  { label: '2営業日前', value: -2 },
  { label: '1営業日前', value: -1 },
  { label: '当日', value: 0 },
  { label: '1営業日後', value: 1 },
  { label: '2営業日後', value: 2 },
  { label: '3営業日後', value: 3 },
  { label: '4営業日後', value: 4 },
  { label: '5営業日後', value: 5 },
];

export const JobScreeningInfoTypes = {
  オープンカンパニー: 'オープンカンパニー',
  インターンシップ: 'インターンシップ',
  面談: '面談',
  座談会: '座談会',
} as const;

export type JobScreeningInfoType =
  typeof JobScreeningInfoTypes[keyof typeof JobScreeningInfoTypes];
